export default __webpack_public_path__ + "static/media/cv.27fcbd94.pdf";